/* eslint-disable import/no-anonymous-default-export */
import apWhite from "../assets/ash_white_knight.png";
import apSilvergrey from "../assets/ash_silver_grey_knight.png";
import ap from "../assets/ap.png";
import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import ashley from "../assets/ashley.png";
import ashleyp from "../assets/ashley-p.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import docker from "../assets/tech/docker.svg";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import kubernetes from "../assets/tech/kubernetes.svg";
import golang from "../assets/tech/golang.png";
import nestjs from "../assets/tech/nestjs.png";
import nextjs from "../assets/tech/next-js.svg";
import terraform from "../assets/tech/terraform.png";
import reactnative from "../assets/tech/react-native.png";
import stripe from "../assets/tech/stripe.png";
import android from "../assets/tech/android.svg";
import ios from "../assets/tech/ios.svg";
import java from "../assets/tech/java.svg";
import swift from "../assets/tech/swift.svg";
import postgresql from "../assets/tech/postgresql.svg";
import serverless from "../assets/tech/serverless.png";
import serverlessFramework from "../assets/tech/serverlessv2.png";
// import python from "../assets/tech/python.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/tech/aws.svg";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";

import albert from "../assets/testimonials/alberthop.jpg";
import steven from "../assets/testimonials/stevenhasnoot.jpg";
import sanne from "../assets/testimonials/sannealbreghs.jpg";
import max from "../assets/testimonials/maxkalis.jpg";
import matthew from "../assets/testimonials/matthewkiernander.jpg";
import aavgeen from "../assets/testimonials/aavgeen.jpg";

import babbel from "../assets/brands/babbel.png";
// import backbase from "../assets/brands/backbase.png";
import backbase from "../assets/brands/bb.svg.png";
import bizcuit from "../assets/brands/bizcuit.png";
import codam from "../assets/brands/codam.png";
import gs4e from "../assets/brands/global-school.png";
import han from "../assets/brands/han.png";
import info from "../assets/brands/info.png";
import lloyds from "../assets/brands/lloyds.png";
import nn from "../assets/brands/nn.png";
import opc from "../assets/brands/opc.png";
import rodeo from "../assets/brands/rodeo.png";
import sgc from "../assets/brands/sgc.png";
import thuisbezorgd from "../assets/brands/thuisbezorgd.png";
import thuisebezord2 from "../assets/projects/thuisbezorg-hero.jpg";
import thuisbezorgd3 from "../assets/projects/thuisbezorgd3.png";
import thuisbezorgd4 from "../assets/projects/thsuibezorgd4.jpg";
import thuisbezorgd6 from "../assets/projects/thuisbezordg6.png";
import yum from "../assets/brands/yum-brands.svg";
import kfc from "../assets/brands/kfc_x.png";
import kfc1 from "../assets/projects/kfc-1.png";
import kfc2 from "../assets/projects/kfc-2.png";
import kfc3 from "../assets/projects/kfc-3.png";
import kfc4 from "../assets/projects/kfc-4.png";
import kfc5 from "../assets/projects/kfc-5.png";
import kfc6 from "../assets/projects/kfc-6.png";
import kfc7 from "../assets/projects/kfc-7.png";
import kfc8 from "../assets/projects/kfc-8.png";
import kfc9 from "../assets/projects/kfc-9.jpg";
import jet1 from "../assets/projects/just-eat-groceries.png";
import jet2 from "../assets/projects/thuisbezorgd-a.jpg";
import ideal_nn from "../assets/projects/nn_ideal.webp";
import nn_building from "../assets/projects/nn_building.jpg";
import postnl from "../assets/brands/postnl.webp";
import postnlLogoFinalX from "../assets/brands/post-nl-logo-2.png";

import codamImg from "../assets/projects/codam.png";
import babbelTwo from "../assets/projects/babbel.png";
import idealImg from "../assets/projects/ideal.png";
import idealLogo from "../assets/brands/ideal-1.jpg";
import agileImg from "../assets/projects/agile-project-management.png";
import tkwyImg from "../assets/projects/thuisbezorgd-cropped.png";
import infoImg from "../assets/projects/emerging-industries.png";
import infoOffice from "../assets/projects/info-office.jpg";
import hanImg from "../assets/projects/han-1.png";
import lloydsImg from "../assets/projects/lloyds-echo-money-talks-experiment-cropped.png";
import codamV2Img from "../assets/projects/codam-1.png";
import codamV1Img from "../assets/projects/codam-2.png";
import codamV3Img from "../assets/projects/codam-college-terrain.jpg";
import gs4e1 from "../assets/projects/gs4e.jpg";
import gs4e2 from "../assets/projects/gs4e2.jpg";
import gs4e3 from "../assets/projects/gs4e3.png";
import unknown1 from "../assets/projects/unkown_uni2.png";
import unknown2 from "../assets/projects/unkown_uni2.png";
import unknown3 from "../assets/projects/unknown3.png";
import u from "../assets/projects/u.png";
import u2 from "../assets/projects/u2.png";
import u34 from "../assets/projects/u34.png";
import u4 from "../assets/projects/unknown-uni.jpg";
import codamNightTime from "../assets/projects/codam-nighttime.jpg";
import hanStudent from "../assets/projects/han-student.jpg";
import surfCatalog1 from "../assets/projects/surf-catalog-1.png";
import surfCatalog2 from "../assets/projects/surf-catalog-2.png";
import idealPayments1 from "../assets/projects/ideal-payments-netherlands.jpg";
import idealPayments2 from "../assets/projects/ideal-payments-banks.png";
import babbel1 from "../assets/projects/babbel-1.png";
import babbel2 from "../assets/projects/babbel-2.png";
import babbel3 from "../assets/projects/babbel-3.png";
import babbel4 from "../assets/projects/babbel-4.png";
import babbel5 from "../assets/projects/babbel-5.png";
import babbel6 from "../assets/projects/babbel-6.png";
import babbel7 from "../assets/projects/babbel-7.png";
import babbel8 from "../assets/projects/babbel-8.png";
import stripeScreen from "../assets/projects/stripe-revenue.png";
import chapterLogo from "../assets/chapter_logo.svg";
import chapterAppPallette from "../assets/chapter-app-pallette.jpg";
import chapterAppPresentation from "../assets/chapter-app-presentation.png";
import lloydsEchoImageTwo from "../assets/projects/echo_project_1.jpg";
import echoDevice from "../assets/projects/echo_device.webp";
import echoDevice2 from "../assets/projects/echo_birds_eye.jpg";
import echoDevice3 from "../assets/projects/kitchen_banking_with_echo.webp";
import echoDevice4 from "../assets/projects/family_banking_at_home.avif";
import babbelApp1 from "../assets/projects/babbel-app-1.webp";
import babbelCheckout from "../assets/projects/babbel_checkout.png";
import idealLogoFinal from "../assets/brands/ideal_logo_x.png";
import postNlLogoFinal from "../assets/brands/post-nl-logo-final.png";
import infoLogo from "../assets/projects/info-logo.jpg";
import stripeNew from "../assets/tech/stripeNew2.jpg";

import ashPrism from "../assets/ash_prism.jpg";

import error from "../assets/error.png";

import consultancyService from "../assets/services/consultancy-service.svg";
import backendService from "../assets/services/backend-service.svg";
import frontendService from "../assets/services/frontend-service.svg";
import mentorshipService from "../assets/services/mentorship-service.svg";

import processStep1a from "../assets/process/process-step-1a.svg";
import processStep1b from "../assets/process/prcoess-step-1b.svg";
import processStep2 from "../assets/process/process-step-2.svg";
import processStep3 from "../assets/process/process-step-3.svg";

export default {
  ap,
  email,
  mobile,
  api,
  ashley,
  ashleyp,
  cpp,
  css,
  docker,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  albert,
  steven,
  sanne,
  max,
  matthew,
  babbel,
  babbelTwo,
  backbase,
  bizcuit,
  codam,
  gs4e,
  han,
  info,
  lloyds,
  nn,
  opc,
  rodeo,
  sgc,
  thuisbezorgd,
  kubernetes,
  golang,
  nestjs,
  nextjs,
  terraform,
  reactnative,
  codamImg,
  idealImg,
  agileImg,
  tkwyImg,
  infoImg,
  hanImg,
  lloydsImg,
  stripe,
  codamV2Img,
  error,
  ashPrism,
  gs4e1,
  gs4e2,
  gs4e3,
  unknown1,
  unknown2,
  unknown3,
  u,
  u2,
  u34,
  u4,
  consultancyService,
  backendService,
  frontendService,
  mentorshipService,
  processStep1a,
  processStep1b,
  processStep2,
  processStep3,
  infoOffice,
  codamNightTime,
  android,
  ios,
  java,
  swift,
  postgresql,
  hanStudent,
  surfCatalog1,
  surfCatalog2,
  idealPayments1,
  idealPayments2,
  thuisebezord2,
  thuisbezorgd3,
  thuisbezorgd4,
  thuisbezorgd6,
  codamV1Img,
  codamV3Img,
  babbel1,
  babbel2,
  babbel3,
  babbel4,
  babbel5,
  babbel6,
  babbel7,
  babbel8,
  stripeScreen,
  chapterLogo,
  chapterAppPallette,
  chapterAppPresentation,
  yum,
  kfc,
  serverless,
  serverlessFramework,
  kfc1,
  kfc2,
  kfc3,
  kfc4,
  kfc5,
  kfc6,
  kfc7,
  kfc8,
  kfc9,
  idealLogo,
  aavgeen,
  apWhite,
  apSilvergrey,
  lloydsEchoImageTwo,
  echoDevice,
  echoDevice2,
  echoDevice3,
  echoDevice4,
  babbelApp1,
  babbelCheckout,
  jet1,
  jet2,
  ideal_nn,
  nn_building,
  postnl,
  idealLogoFinal,
  postNlLogoFinal,
  postnlLogoFinalX,
  infoLogo,
  stripeNew,
};
